(function () {
  'use strict';

  var CookiesEuBanner = function (launchFunction, waitAccept, useLocalStorage) {
    if (!(this instanceof CookiesEuBanner)) {
      return new CookiesEuBanner(launchFunction, waitAccept, useLocalStorage);
    }

    this.cookieTimeout = 31104000000; // 12 months in milliseconds
    this.bots = /bot|crawler|spider|crawling/i;
    this.cookieName = 'hasConsent';
    this.trackingCookiesNames = ['__utma', '__utmb', '__utmc', '__utmt', '__utmv', '__utmz', '_ga', '_gat', '_gid'];
    this.launchFunction = launchFunction;
    this.waitAccept = waitAccept || false;
    this.useLocalStorage = useLocalStorage || false;
    this.init();
  };

  CookiesEuBanner.prototype = {
    init: function () {
      var isBot = this.bots.test(navigator.userAgent);
      var dnt = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
      var isToTrack = (dnt !== null && dnt !== undefined) ? (dnt && dnt !== 'yes' && dnt !== 1 && dnt !== '1') : true;

      if (isBot || !isToTrack || this.hasConsent() === false) {
        this.removeBanner(0);
        return false;
      }

      if (this.hasConsent() === true) {
        this.launchFunction();
        return true;
      }

      this.showBanner();

      if (!this.waitAccept) {
        this.setConsent(true);
      }
    },

    showBanner: function () {
      var _this = this,
          banner = document.getElementById('cookies-eu-banner'),
          rejectButton = document.getElementById('cookies-eu-reject'),
          acceptButton = document.getElementById('cookies-eu-accept');

      if (!banner) return;

      banner.style.display = 'block';

      if (acceptButton) {
        acceptButton.addEventListener('click', function () {
          _this.removeBanner();
          _this.setConsent(true);
          _this.launchFunction();
        });
      }

      if (rejectButton) {
        rejectButton.addEventListener('click', function () {
          _this.removeBanner();
          _this.setConsent(false);
          _this.trackingCookiesNames.forEach(_this.deleteCookie);
        });
      }
    },

    setConsent: function (consent) {
      if (this.useLocalStorage) {
        localStorage.setItem(this.cookieName, consent);
      } else {
        this.setCookie(this.cookieName, consent);
      }
    },

    hasConsent: function () {
      return document.cookie.includes(`${this.cookieName}=true`) || localStorage.getItem(this.cookieName) === 'true';
    },

    setCookie: function (name, value) {
      var date = new Date();
      date.setTime(date.getTime() + this.cookieTimeout);
      document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;secure;SameSite=Lax`;
    },

    deleteCookie: function (name) {
      document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/`;
    },

    removeBanner: function () {
      var banner = document.getElementById('cookies-eu-banner');
      if (banner) banner.remove();
    }
  };

  window.CookiesEuBanner = CookiesEuBanner;
})();

export default window.CookiesEuBanner;
